import React, { ElementType } from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Button, Typography } from '@guildeducationinc/recess';
import { trackEvent } from 'src/services/analytics';
import { Link } from 'react-router-dom';
import ProgramQuizPictogram from '@guildeducationinc/recess/pictograms/ProgramQuizPictogram';
import styles from './QuizCallout.module.scss';

export const QuizCallout: React.FC = () => {
	const isMobile = useIsMobile();

	return (
		<section className={styles.wrapper} data-testid='quiz-callout'>
			{!isMobile ? <ProgramQuizPictogram className={styles.pictogram} size={64} /> : null}
			<div className={styles.text}>
				<Typography className={styles.title} variant='h3'>
					Take the program quiz
				</Typography>
				<Typography variant='body1'>
					Answer a few questions about your background and interests to get personalized
					recommendations.
				</Typography>
				<Button
					Component={Link as unknown as ElementType}
					className={styles.button}
					onClick={() =>
						trackEvent('Clickable', {
							location: 'recommendations',
							tag: 'quiz_cta',
							text: 'take_the_quiz',
							type: 'button',
						})
					}
					testid='results-quiz-cta'
					to='/quiz'
				>
					Take the quiz
				</Button>
			</div>
		</section>
	);
};
